module.exports = __webpack_public_path__ + "static/media/free-review-banner.955c6efe.png";